(() => {
  if (customElements.get('clinicians-slider')) {
    return;
  }

  class CustomElement extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        spaceBetween: 8,
        navigation: {
          nextEl: this.querySelector('[data-arrow-next]'),
          prevEl: this.querySelector('[data-arrow-prev]'),
        },
      };

      if (this.hasAttribute('data-alt')) {
        this.options = {
          spaceBetween: 16,
          slidesPerView: 1,
          navigation: {
            nextEl: this.querySelector('[data-arrow-next]'),
            prevEl: this.querySelector('[data-arrow-prev]'),
          },
          breakpoints: {
            750: {
              initialSlide: 1,
              centeredSlides: true,
              slidesPerView: 'auto',
            },
          },
        };
      }
    }

    connectedCallback() {
      this.sliderEl = this.querySelector('[data-slider]');
      if (!this.sliderEl) {
        return;
      }
      this.initSlider();
    }

    initSlider() {
      this.slider = new Swiper(this.sliderEl, this.options);
    }
  }

  customElements.define('clinicians-slider', CustomElement);
})();
